import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AdminRoleService {

  // adminRoles: Array<any> = ["ROLE_ACCOUNT_ADMIN", "ROLE_ACCOUNT_DEVELOPER", "ROLE_ACCOUNT_FINANCE_USER", "ROLE_FMC_AGENT"];
  adminRoles: Array<any> = ["ROLE_ACCOUNT_ADMIN", "ROLE_ACCOUNT_DEVELOPER", "ROLE_ACCOUNT_FINANCE_USER"];

  getAdminRoles() {
    return this.adminRoles;
  }
}
